import React, { useState, useEffect, useCallback, useRef } from 'react';
import { getData, getcountries} from '../../../services/event/emrevenueForms/emselfRegistrationServices';
import { Modal, Button, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import cardIcon from "../../../../src/assets/img/hdfc_card.webp";
import paypalIcon  from "../../../../src/assets/img/paypal_icon.webp";
import razorpayIcon  from "../../../../src/assets/img/razorpay_icon.webp";
import checkoutIcon  from "../../../../src/assets/img/checkout_icon.webp";

const subDomain = localStorage.getItem('sub_domain') || '';

const EmSelfRegistration = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({updatedAt : '' });
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const debounceTimeoutRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  // const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  // const [selectedData, setSelectedData] = useState(null);
  // Filter States
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [dropdownData, setDropdownData] = useState({
        countries: [],
    }); 
  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
    
   // Debounce Effect
    useEffect(() => {
      if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
  
      debounceTimeoutRef.current = setTimeout(() => {
        setDebouncedSearch(searchText);
        setCurrentPage(1); // reset page only when actual search triggered
      }, 600); // 500ms debounce delay
  
      return () => clearTimeout(debounceTimeoutRef.current);
    }, [searchText]);
  
    // Fetch data list
      const fetchData = useCallback(async () => {
          setLoading(true);
          try {
            const filters = {};
            if (subDomain) filters.domain = subDomain; // ✅ Add this line
            if (countryFilter) filters.country = countryFilter;
      
            const params = {
              is_self_reg: 1,
              page: currentPage,
              limit: rowsPerPage,
              search: debouncedSearch,
              filters,
              startDate: startDate || null,
              endDate: endDate || null,
            };
      
           const response = await getData(params);
           // ✅ Console log the full API response
            console.log('Fetched Data:', response);
            setDataList(response.rows);
            setTotalRows(response.count);
          } catch (error) {
            console.error('Failed to fetch data:', error);
          } finally {
            setLoading(false);
          }
        }, [currentPage, rowsPerPage, debouncedSearch, countryFilter, startDate, endDate]);
      
  // Fetch all dropdown data
    const fetchDropdownData = useCallback(async () => {
      try {
        const [country] = await Promise.all([
          getcountries(),            
        ]);
    
        setDropdownData({
          countries: country,
        });
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    }, []);

   useEffect(() => {
        fetchDropdownData();
    }, [fetchDropdownData]);
    
    useEffect(() => {
        fetchData();
    }, [fetchData]);

  //delete
    // const handleDelete = async () => {
    //     if (selectedData) {
    //       // Optimistically remove the data from the list
    //       setDataList((prev) => prev.filter((data) => data.selfregistration_id !== selectedData.selfregistration_id));
    //       // Proceed with the actual delete request
    //       await deleteData(selectedData);
    //       setShowDeleteConfirmModal(false);
    //     }
    // };
  
    // const openDeleteConfirmModal = (data) => {
    //   setSelectedData(data);
    //   setShowDeleteConfirmModal(true);
    // };
    
  //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };

  const openModal = (data) => {
    setForm(data);
    setShowViewModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value.trimStart());
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  };

  //payment icon
  const getPaymentIcon = (type) => {
    switch (type.toLowerCase()) {
      case "card":
        return cardIcon;
      case "paypal":
        return paypalIcon
      case "razorpay":
        return razorpayIcon
      case "initiated":
        return checkoutIcon
      default:
        return null;
    }
  };

  // Define columns for DataTable
  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '60px',
    },
    {
      name: 'Date',
      selector: (row) => new Date(row.createdAt).toLocaleDateString('en-CA'),
      sortable: true,
      wrap: true,
    },
    {
      name: 'Sub Domain',
      // selector: (row) => row.domain,
      cell: (row) => <span title={row.domain}>{row.domain}</span>,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Full Name',
      // selector: (row) => `${row.first_name} ${row.last_name}`,
      cell: (row) => (
      <span title={`${row.first_name} ${row.last_name}`}>
        {row.first_name} {row.last_name}
      </span>),
      sortable: true,
      wrap: true,
    },
    {
      name: 'Country',
      // selector: (row) => getCountryName(row.country),
      cell: (row) => <span title={getCountryName(row.country)}>{getCountryName(row.country)}</span>,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Email',
      // selector: (row) => row.email,
      cell: (row) => <span title={row.email}>{row.email}</span>,
      sortable: true,
      wrap: true,
    },
    {
        name: 'Amount',
        selector: (row) => {
          let currencySymbol = '';
          
          // Determine currency symbol based on currency_type
          switch (row.currency_type) {
            case 1: // USD
              currencySymbol = '$';
              break;
            case 2: // EUR
              currencySymbol = '€';
              break;
            case 3: // INR
              currencySymbol = '₹';
              break;
            default:
              currencySymbol = ''; // Default to no symbol if currency type is unknown
          }
    
          // Return the amount with the appropriate currency symbol
          return <b className='fs-4'>{currencySymbol} {row.amount}</b>;
        },
        sortable: true,
        wrap: true,
      },
     {
        name: "Payment Mode",
        cell: (row) => {
          const icon = getPaymentIcon(row.payment_type);

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              {icon ? (
                <img
                  src={icon}
                  width={70}
                  alt={row.payment_type}
                  style={{
                    borderRadius: "6px",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  }}
                />
              ) : (
                <span style={{ fontWeight: "500" }}>{row.payment_type}</span>
              )}
            </div>
          );
        },
        sortable: true,
        wrap: true,
      },
      {
        name: 'Status',
        cell: (row) => {
          const status = row.status;

          let statusClass = '';
          let statusText = '';

          if (status === 'CHARGED') {
            statusClass = 'bg-success text-center text-white py-1 rounded w-100';
            statusText = 'Success';

          } else if (status === 'AUTHORIZATION_FAILED' || status === 'AUTHENTICATION_FAILED') {
            statusClass = 'bg-danger text-center text-white py-1 rounded w-100';
            statusText = 'Failed';

          } else if (status === 'PENDING_VBV' || status === 'NEW') {
            statusClass = 'bg-warning text-center text-white py-1 rounded w-100';
            statusText = 'Pending';

          } else if (status === 'JUSPAY_DECLINED') {
            statusClass = 'bg-secondary text-center text-white py-1 rounded w-100';
            statusText = 'Declined';

          } else {
            statusClass = 'bg-secondary text-center text-white py-1 rounded w-100';
            statusText = status || 'Unknown';
          }

          return (
            <div className={`status-btn ${statusClass}`}>
              {statusText}
            </div>
          );
        },
        sortable: true,
        wrap: true,
      },
      {
        name: 'Actions',
        cell: (row) => (
          <div>
            <Button variant="primary" size="sm" onClick={() => openModal(row)} className="me-2">
              <i className="align-middle far fa-fw fa-eye"></i>
            </Button>
            {/* <Button variant="danger" className="me-2" size="sm" onClick={() => openDeleteConfirmModal(row)} > <i className="align-middle fas fa-fw fa-trash"></i></Button> */}
            {row.payment_type?.toLowerCase() !== "paypal" && (
            <Button variant="info" size="sm" title="Open Registration Status" onClick={() => {
              window.open(
                `https://www.${subDomain}.scientexconference.com/registrationstatus?param=${row.selfregistration_id}`,
                '_blank'
              );
              // Optional: reload data after short delay
              setTimeout(() => window.location.reload(), 1000);
              }}
              >
              <i className="fas fa-link"></i>
              </Button>
              )} 
          </div>
        ),
      },
  ];
  

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        <div className=" row m-3 d-flex flex-column gap-3 ">
          <div className="d-flex gap-2">
            {/* Dropdown for Filters */}      
            <div className="col-md-2">
            <span className='fs-5 text-dark'>Countries</span>
            <select
              className="form-control"
              value={countryFilter}
              onChange={(e) => { setCountryFilter(e.target.value); setCurrentPage(1); }}
            >
              <option value="">All Countries</option>
              {dropdownData.countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>
 
            {/* Start Date and End Date Input */}
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Start Date</span>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => { setStartDate(e.target.value); setCurrentPage(1); }}
              />
            </div>
            <div className="col-md-2">
              <span className='fs-5 text-dark'>End Date</span>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => { setEndDate(e.target.value); setCurrentPage(1); }}
              />
            </div>
          </div> 
        </div>
         {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center w-100"
                      style={{ minHeight: "300px" }}
                    >
                      <Spinner /> {/* Centered Spinner */}
                    </div>
                            ) :(
                  <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className="fs-4 text-dark">Conference Leads / Revenue Forms / Self Registration</p>
            </div>
          </div>

          <DataTable
                columns={columns}
                data={dataList}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationPerPage={rowsPerPage}
                paginationRowsPerPageOptions={[10, 30, 50, 100, 500]}
                onChangePage={handlePageChange}
                paginationDefaultPage={currentPage}
                onChangeRowsPerPage={handlePerRowsChange}
                highlightOnHover
                responsive
                striped
                subHeader
                subHeaderComponent={
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search"
                    value={searchText}
                    onChange={handleSearchChange}
                  />
                }
              />

          {/* Modal for Viewing Refund Details */}
          <Modal className="modal-lg" show={showViewModal} onHide={() => setShowViewModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>View</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Table striped bordered hover responsive className="table-sm">
                <thead>
                  <tr>
                    <th className="bg-secondary text-white" colSpan={2}>Registered User Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>Title</td><td>{form.title}</td></tr>
                  <tr><td>First Name</td><td>{form.first_name}</td></tr>
                  <tr><td>Last Name</td><td>{form.last_name}</td></tr>
                  <tr><td>County</td><td>{getCountryName(form.country)}</td></tr>
                  <tr><td>Email Id </td><td>{form.email}</td></tr>
                  <tr><td>Contact Number</td><td>{form.contactnumber}</td></tr>
                  <tr><td>Address</td><td>{form.postal_address}</td></tr>
                </tbody>

                    <thead>
                      <tr><th className="bg-secondary text-white" colSpan={2}>Registration Details</th></tr>
                    </thead>
                    <tbody>
                      <tr><td>Registered Date</td><td>{form.createdAt}</td></tr>
                      <tr><td>Order Id</td><td>{form.selfregistration_id }</td></tr>
                      <tr><td>Transaction Id</td><td>{form.trnx}</td></tr>
                      <tr><td>Registration Amount</td><td>{form.amount}</td></tr>
                      <tr><td>Registration Status</td><td>{form.status}</td></tr>
                      <tr><td>Registration Mode</td><td>{form.payment_type}</td></tr>
                    </tbody>        
              </Table>
            </Modal.Body>
          </Modal>
           {/* Delete Confirmation Modal */}
            {/* <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Are you sure you want to delete this row?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                  Cancel
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                  Yes, Delete
                </Button>
              </Modal.Footer>
            </Modal> */}
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default EmSelfRegistration;

